/* -disable import/prefer-default-export */
import styled from 'styled-components';

const FilterItemTextWrapper = styled.div`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const FilterItemText = styled.span`
  font-size: 12px;

  && > span {
    visibility: hidden;
    white-space: normal;
    overflow: auto;
    max-width: 200px;
    display: block;
    background-color: var(--luft-secondary);
    color: #fff;
    padding: 5px;
    position: absolute;
    top: 0;
    font-size: 10px;
    z-index: 10;
    line-height: 1.4;
  }

  &&:hover {
    && > span {
      visibility: visible;
    }
  }
`;

const LoaderContainer = styled.div`
  && > div {
    flex-direction: row;
  }
`;

export const S = {
  FilterItemTextWrapper,
  FilterItemText,
  LoaderContainer,
};
